import { i18n } from "@dehub/theme";
import { Text } from "@mantine/core";
import { openConfirmModal } from "@mantine/modals";

export const Dialog = {
  confirm: (text: string, callback: (key: "confirm" | "cancel") => void) =>
    openConfirmModal({
      centered: true,
      title: i18n.t("common:confirm.title"),
      children: <Text size="sm">{text}</Text>,
      labels: {
        confirm: i18n.t("common:confirm.yes"),
        cancel: i18n.t("common:confirm.no"),
      },
      onCancel: () => callback("cancel"),
      onConfirm: () => callback("confirm"),
    }),
};
